// extracted by mini-css-extract-plugin
export default {"modal":"ioWlCQ","container":"BZY79N","avatar":"cnFoOG","form":"OW9lfh","footer":"zwj_64","submit":"Y2da9y"};